import { render, staticRenderFns } from "./AutoPostBoostingFooter.vue?vue&type=template&id=5028cf3d&scoped=true&"
import script from "./AutoPostBoostingFooter.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoostingFooter.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoostingFooter.vue?vue&type=style&index=0&id=5028cf3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028cf3d",
  null
  
)

export default component.exports